export default {
	methods: {
		taxNumberMask(number) {
			return number && number.substring(0, 1) == '8' ? '##########' : '########-#-##';
		}
	}
};
